import * as React from 'react'
import styled, { css } from 'styled-components'

import * as entities from '@owl-nest/entities'
import * as money from '@owl-nest/money'

import * as ds from '@bob/design-system'
import * as entity from '@boutique/entities'
import * as url from '@boutique/url'

export type ProductsProps = {
  brand: entity.brand.Brand
  products: entities.product.SearchHitProduct[]
}

export function Products({ brand, products }: ProductsProps): React.ReactElement {
  return (
    <Container>
      <ds.styles.heading.Title3>Disponible sur Ulule Boutique</ds.styles.heading.Title3>
      <ds.LineGridLayout>
        {products.map((hit) => {
          return (
            <ds.ProductCard
              brand={brand.name}
              key={hit.href}
              compareAtPriceRange={
                hit.compareAtPriceRange
                  ? [money.format(hit.compareAtPriceRange[0]), money.format(hit.compareAtPriceRange[1])]
                  : undefined
              }
              criteria={hit.criteria}
              href={hit.href}
              openInNewTab
              picture={{
                ...hit.picture,
                nativeLazyLoad: true,
              }}
              priceRange={[money.format(hit.priceRange[0]), money.format(hit.priceRange[1])]}
              title={hit.title}
            />
          )
        })}
      </ds.LineGridLayout>
      <SeeMoreButton
        small
        hide={products.length < 16}
        href={url.products({ query: { facetFilters: { brands: [brand.slug] } } }).path}
      >
        Voir plus
      </SeeMoreButton>
    </Container>
  )
}

const Container = styled(ds.Container)`
  margin-bottom: 80px;
  text-align: center;

  ${ds.LineGridLayout} {
    text-align: left;
  }

  ${ds.styles.heading.Title3} {
    margin: 100px 0 20px;
    text-align: left;
  }
`

const SeeMoreButton = styled(ds.ButtonAsLink)<{ hide: boolean }>`
  width: 100%;
  margin-top: 50px;

  @media screen and (${ds.breakpoint.TABLET}) {
    width: 314px;
  }

  @media screen and (${ds.breakpoint.LAPTOP}) {
    ${({ hide }) =>
      hide &&
      css`
        display: none;
      `}
  }
`
